<a
  class="flex-shrink-0 rounded-m"
  [style.backgroundColor]="backgroundColor | contentBuilderColor: 'neutral-100'"
  [style.color]="textColor | contentBuilderColor: '00000'"
  [target]="linkTarget"
  [link]="linkUrl"
  tabindex="-1"
>
  <div
    class="flex flex-col h-full shadow-md rounded-m"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
  >
    @if (backgroundImage) {
      <img
        [src]="backgroundImage.url"
        [href]="'linkUrl'"
        class="object-cover h-40 w-52"
        [ngClass]="heading ? 'rounded-t-m' : 'rounded-m'"
      />
    }
    @if (heading || content) {
      <div
        class="relative px-6 py-4 overflow-hidden text-neutral-50"
        [ngClass]="backgroundImage ? 'h-24' : 'flex-1'"
      >
        <h3
          class="text-base font-bold"
          [style.color]="textColor | contentBuilderColor"
        >
          {{ heading }}
        </h3>
        @if (content) {
          <app-text-atom
            [style.color]="textColor | contentBuilderColor"
            class="line-clamp-2 text-10px"
            [content]="content"
          ></app-text-atom>
        }
      </div>
    }
  </div>
</a>
